import React from "react";
import ActivityHistory from "@app/components/activity/ActivityHistory";

const Activities: React.FC<{ orderId: number; refreshToken?: number }> = ({ orderId, refreshToken }) => {
  return (
    <ActivityHistory
      entityType="orders"
      entityId={orderId}
      title="Order History"
      refreshToken={refreshToken}
    />
  );
};

export default Activities;
